<template>
  <li
    :data-menuanchor="section.id"
    :class="{
      'section-link': true,
      'visited': visited,
      'active': active,
      'locked': section.locked
    }"
  >
    <a
      :href="sectionAddress"
      @click="select()"
      class="nav-link"
    >
      <span class="bullet">
        <span class="icon">
          <home-icon v-if="section.icon === 'home'" class="icon-shape home" />
          <star-icon v-if="section.icon === 'star'" class="icon-shape star" />
          <rays-icon v-if="section.icon === 'star'" class="rays" />
        </span>
      </span>
      <span class="title">
        {{ section.title }}
      </span>
    </a>
  </li>
</template>

<script>
import HomeIcon from '../../assets/icons/home.svg?inline'
import StarIcon from '../../assets/icons/star.svg?inline'
import RaysIcon from '../../assets/icons/rays2.svg?inline'

export default{
  name: 'navigation-link',
  components: {
    'home-icon': HomeIcon,
    'star-icon': StarIcon,
    'rays-icon': RaysIcon
  },
  props: {
    section: Object,
    active: Boolean,
    visited: Boolean
  },
  data: function() {
    return {
      hovered: false
    }
  },
  computed: {
    sectionAddress() {
      return !this.section.locked
        ? `#${this.section.id}`
        : ''
    }
  },
  methods: {
    select() {
      this.$emit('select', this.section)
    }
  }
}
</script>

<style scoped lang="scss">
/** navigation-link **/
@import '../../theme';
@import './variables';

li {
  list-style: none;
}

$transitions: color $t-m linear,
  background-color $t-s linear,
  border-color $t-s linear,
  transform $t-m ease-out;
$scale: 0.7;
$scale-inverse: 1 + (1 - $scale);

.section-link {
  display: block;
  width: 100%;
  margin-bottom: $dot-margin-short;
  position: relative;

  @include media-vertical-breakpoint-up(sm) {
    margin-bottom: $dot-margin-mobile;
  }

  @include media-breakpoint-up(lg) {
    margin-bottom: $dot-margin;
  }

  /* Dot connecting line */
  &:not(:first-child) {
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: $bullet-width-mobile * 0.5;
      height: $line-h-short;
      transform: translate(1px, $line-start-short);
      border: #{$nav-border-thickness/2} solid rgba($black, 0.2);
      z-index: zespri-layer(behind-background);

      @include media-vertical-breakpoint-up(sm) {
        height: $line-h-mobile;
        transform: translate(1px, $line-start-mobile);
      }

      @include media-breakpoint-up(lg) {
        height: $line-h;
        left: $bullet-width * 0.5;
        transform: translate(1px, $line-start);
      }
    }
  }
}

.nav-link {
  &:not(.locked) {
    cursor: pointer;
  }

  display: flex;
  align-items: center;
  position: relative;

  &:hover,
  &:focus,
  &:active {
    outline: none;

    .icon {
      background-color: rgba(zespri-brand-color(dark-green), 0.5);
    }
  }
}

.bullet {
  @include flex-centered;
  position: relative;
  width: $bullet-width-mobile;
  height: $bullet-width-mobile;
  min-width: $bullet-width-mobile;
  min-height: $bullet-width-mobile;
  transform: scale($scale);

  border-radius: 50%;
  text-decoration: none;
  background-color: transparent;
  transition: $transitions;
  border: $nav-border-thickness solid transparent;

  @include media-breakpoint-up(lg) {
    width: $bullet-width;
    height: $bullet-width;
    min-width: $bullet-width;
    min-height: $bullet-width;
  }
}

.icon {
  width: $dot-s-mobile;
  height: $dot-s-mobile;
  transform: scale(#{$scale-inverse});
  @include flex-centered;

  color: zespri-brand-color(yellow); // necessary?
  border: $nav-border-thickness solid $black;
  border-radius: 50%;
  transition: $transitions;

  .star, .home {
    fill: zespri-brand-color(dark-green);
  }

  @include media-breakpoint-up(lg) {
    width: $dot-s;
    height: $dot-s;
  }
}

$end-offset: -34px;
@keyframes explode {
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: $end-offset;
  }
}

.rays {
  @include absolute-centered;
  width: 66px;
  height: 66px;

  stroke: zespri-brand-color(dark-green);
  stroke-width: 3px;
  stroke-linecap: round;

  @include media-breakpoint-up(lg) {
    width: 50px;
    height: 50px;
  }

  .line {
    stroke-dashoffset: 0;
    stroke-dasharray: 8px 20px;
  }
}

.icon-shape {
  width: 70%;
}

.title {
  margin-left: 25px;
  white-space: nowrap;
  @include zespri-tiny-title-responsive;

  @include media-breakpoint-up(lg) {
    margin-left: 15px;
  }
}

.active {
  .bullet {
    border-color: $black;
    background-color: zespri-brand-color(yellow);
    transform: scale(1);
  }

  .icon {
    background-color: zespri-background-dark();
    transform: scale(1);

    .star, .home {
      fill: zespri-brand-color(yellow);
    }
  }

  .rays {
    .line {
      stroke-dashoffset: $end-offset;
      animation: explode 0.8s ease-out 0s 1;
    }
  }
}

.visited {
  &:before {
    background-color: zespri-background-dark();
  }

  .icon {
    background-color: zespri-background-dark();

    .star, .home {
      fill: zespri-brand-color(yellow);
    }
  }
}

.locked {
  opacity: 0.5;
  pointer-events: none;
}

</style>
